/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Humidityactualsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Actual humidity setpoint" |
*
* @param {Ahu_History_Key_Humidityactualsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_humidityactualsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Humidityactualsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Humidityactualsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Actual humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne réelle d'humidité")
});
export { ahu_history_key_humidityactualsetpoint2 as "ahu_history_key_humidityActualSetpoint" }